import { render, staticRenderFns } from "./customizedServiceDetail.vue?vue&type=template&id=621ae5da&scoped=true"
import script from "./customizedServiceDetail.vue?vue&type=script&lang=js"
export * from "./customizedServiceDetail.vue?vue&type=script&lang=js"
import style0 from "./customizedServiceDetail.vue?vue&type=style&index=0&id=621ae5da&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621ae5da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('621ae5da')) {
      api.createRecord('621ae5da', component.options)
    } else {
      api.reload('621ae5da', component.options)
    }
    module.hot.accept("./customizedServiceDetail.vue?vue&type=template&id=621ae5da&scoped=true", function () {
      api.rerender('621ae5da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/printingPage/one688/components/customizedServiceDetail.vue"
export default component.exports